
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.5 0a6.456 6.456 0 00-4.582 1.908L.575.564 0 4.541l4.028-.523L2.68 2.67A5.386 5.386 0 016.5 1.083 5.423 5.423 0 0111.917 6.5 5.423 5.423 0 016.5 11.917a5.418 5.418 0 01-4.815-2.949l-.93.567A6.495 6.495 0 006.5 13a6.5 6.5 0 000-13z","fill":"#161619"}})])
          )
        }
      }
    